(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@mui/material/styles'), require('deepmerge'), require('core-js/modules/es.array.is-array.js'), require('core-js/modules/es.array.find.js'), require('react/jsx-runtime'), require('react'), require('@mui/material'), require('@mui/styles'), require('@emotion/react'), require('core-js/modules/es.array.iterator.js'), require('core-js/modules/es.object.to-string.js'), require('core-js/modules/web.dom-collections.iterator.js'), require('facepaint')) :
    typeof define === 'function' && define.amd ? define(['exports', '@mui/material/styles', 'deepmerge', 'core-js/modules/es.array.is-array.js', 'core-js/modules/es.array.find.js', 'react/jsx-runtime', 'react', '@mui/material', '@mui/styles', '@emotion/react', 'core-js/modules/es.array.iterator.js', 'core-js/modules/es.object.to-string.js', 'core-js/modules/web.dom-collections.iterator.js', 'facepaint'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.UiTheme = {}, global.styles, global.deepmerge, null, null, global.jsxRuntime, global.React, global.material, global.styles$1, global.emotionReact, null, null, null, global.facepaint));
})(this, (function (exports, styles, deepmerge, es_array_isArray_js, es_array_find_js, jsxRuntime, React, material, styles$1, react, es_array_iterator_js, es_object_toString_js, web_domCollections_iterator_js, facepaint) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var deepmerge__default = /*#__PURE__*/_interopDefaultLegacy(deepmerge);
    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var facepaint__default = /*#__PURE__*/_interopDefaultLegacy(facepaint);

    var typography = {
      htmlFontSize: 16,
      fontFamily: "Lato, Helvetica Neue, Segoe UI, sans-serif",
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      h1: {
        fontWeight: 700,
        fontSize: "3rem",
        lineHeight: 1.0417,
        letterSpacing: "normal",
        marginTop: "2rem",
        marginBottom: "2rem"
      },
      h2: {
        fontWeight: 700,
        fontSize: "2rem",
        lineHeight: 1.0625,
        letterSpacing: "normal",
        marginTop: "1rem",
        marginBottom: "1rem"
      },
      h3: {
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: 1.084,
        letterSpacing: "normal",
        marginTop: "0.5rem",
        marginBottom: "0.5rem"
      },
      h4: {
        fontWeight: 700,
        fontSize: "1.25rem",
        lineHeight: 1.1,
        letterSpacing: "normal",
        marginTop: "0.5rem",
        marginBottom: "0.5rem"
      },
      h5: {
        fontWeight: 700,
        fontSize: "1.15rem",
        lineHeight: 1.11,
        letterSpacing: "normal",
        marginTop: "0.25rem",
        marginBottom: "0.25rem"
      },
      h6: {
        fontWeight: 500,
        fontSize: "1.25rem",
        lineHeight: 1.6,
        letterSpacing: "normal"
      },
      subtitle1: {
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.75,
        letterSpacing: "normal"
      },
      subtitle2: {
        fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 1.57,
        letterSpacing: "normal"
      },
      body1: {
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5,
        letterSpacing: "normal"
      },
      body1Highlight: {
        fontWeight: 700,
        fontSize: "1rem",
        lineHeight: 1.5,
        letterSpacing: "normal"
      },
      body2: {
        fontWeight: 400,
        fontSize: "0.875rem",
        lineHeight: 1.43,
        letterSpacing: "normal"
      },
      body2Highlight: {
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: 1.43,
        letterSpacing: "normal"
      },
      button: {
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: 1.75,
        letterSpacing: "normal",
        textTransform: "capitalize"
      },
      caption: {
        fontWeight: 400,
        fontSize: "0.75rem",
        lineHeight: 1.66,
        letterSpacing: "normal"
      },
      overline: {
        fontWeight: 400,
        fontSize: "0.75rem",
        lineHeight: 2.66,
        letterSpacing: "normal",
        textTransform: "uppercase"
      },
      formLabel: {
        fontWeight: 700,
        fontSize: "0.875rem",
        lineHeight: "16px",
        textTransform: "capitalize",
        fontFamily: "Lato, Helvetica Neue, Segoe UI, sans-serif"
      },
      formError: {
        fontWeight: 400,
        fontSize: "0.875rem",
        lineHeight: "18px",
        textTransform: "capitalize",
        fontFamily: "Lato, Helvetica Neue, Segoe UI, sans-serif"
      }
    };

    var palette = {
      primary: {
        main: "rgba(0, 110, 250, 1)",
        dark: "rgba(0, 76, 173, 1)",
        light: "rgba(71, 152, 255, 1)",
        contrastText: "#fff"
      },
      secondary: {
        main: "#FFAA00",
        dark: "rgba(179, 119, 0, 1)",
        light: "rgba(255, 195, 76, 1)",
        contrastText: "#fff"
      },
      translucent: {
        main: "#fff",
        dark: "#000",
        light: "#fff",
        contrastText: "#fff"
      },
      danger: {
        main: "rgba(225, 36, 55, 1)",
        dark: "rgba(161, 22, 36, 1)",
        light: "rgba(234, 102, 116, 1)",
        contrastText: "#fff"
      },
      warning: {
        main: "#E86925",
        contrastText: "#fff"
      },
      success: {
        main: "#217A37",
        contrastText: "#fff"
      },
      divider: "rgba(0, 0, 0, 0.25)",
      action: {
        active: "#fff",
        activatedOpacity: 0.30,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.30,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "#ccc",
        disabledBackground: "#fff",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.15
      },
      brand: {
        yellow: {
          main: "#FFCD00"
        }
      },
      tonalOffset: 0.30
    };

    var breakpoints$1 = {
      keys: ["xs", "sm", "md", "lg", "xl"],
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1600
      }
    };

    var base = {
      breakpoints: breakpoints$1,
      typography: typography,
      palette: palette,
      elevations: ["none", "0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 30px -8px rgba(0, 0, 0, 0.2)", " 0px 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 8px 60px -16px rgba(0, 0, 0, 0.2)"],
      shape: {
        borderRadius: 4,
        imagesRadius: 8
      },
      transitions: {
        easing: {
          easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
          easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
          easeIn: "cubic-bezier(0.4, 0, 1, 1)",
          sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
        },
        duration: {
          shortest: 150,
          shorter: 200,
          "short": 250,
          standard: 300,
          complex: 375,
          enteringScreen: 225,
          leavingScreen: 195
        }
      },
      zIndex: {
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500
      }
    };

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var light = {
      palette: {
        background: {
          // grey[700]
          paper: "#f4f4f4",
          // grey[800]
          "default": "#fff",
          // grey[800]
          elevated: "#ffffff"
        },
        mode: "light",
        text: {
          // grey[100]
          primary: "#333",
          secondary: "rgba(255, 255, 255, 0.7)",
          disabled: "rgba(255, 255, 255, 0.5)",
          // grey[800]
          hint: "#fff"
        },
        grey: {
          "100": "#333",
          "200": "#666",
          "300": "#888",
          "400": "#ccc",
          "500": "#d9d9d9",
          "600": "#ebebeb",
          "700": "#f4f4f4",
          "800": "#fff"
        }
      }
    };

    var dark = {
      palette: {
        // The colors used to style the text
        mode: "dark",
        // Consistency between these values is important.
        background: {
          // gray[700]
          paper: "#222",
          // gray[600]
          "default": "#444",
          //
          elevated: "#333333"
        },
        text: {
          // grey[100]
          primary: "#fff",
          secondary: "rgba(255, 255, 255, 0.7)",
          disabled: "rgba(255, 255, 255, 0.5)",
          // grey[800]
          hint: "#000"
        },
        grey: {
          "100": "#fff",
          "200": "#ccc",
          "300": "#999",
          "400": "#888",
          "500": "#666",
          "600": "#444",
          "700": "#222",
          "800": "#000"
        }
      }
    };

    function createTheme(options) {
      var _a;

      if (options === void 0) {
        options = {};
      }

      var isLight = ((_a = options === null || options === void 0 ? void 0 : options.palette) === null || _a === void 0 ? void 0 : _a.mode) === "light"; // get base theme config and merge it with the options

      var theme = deepmerge__default["default"](base, options); // merge light or dark to make sure we get proper defaults

      theme = deepmerge__default["default"](isLight ? light : dark, theme); // create the theme.

      return styles.createTheme(__assign(__assign({}, theme), {
        components: {
          MuiButtonBase: {
            defaultProps: {
              disableRipple: true // No more ripple, on the whole application

            }
          },
          MuiScopedCssBaseline: {
            styleOverrides: {
              root: {
                backgroundColor: "unset"
              }
            }
          }
        }
      }));
    }

    var DispatchContext = /*#__PURE__*/React__default["default"].createContext({});

    if (process.env.NODE_ENV !== "production") {
      DispatchContext.displayName = "ThemeDispatchContext";
    }

    var CHANGE_PALETTE_MODE = "[THEME SELECTOR] Change palette mode";
    var CHANGE_THEMES = "[THEME SELECTOR] Change theme/s";

    var ChangePaletteModeAction = function () {
      function ChangePaletteModeAction(payload) {
        this.type = CHANGE_PALETTE_MODE;
        this.payload = payload;
      }

      return ChangePaletteModeAction;
    }();

    var ChangeThemesAction = function () {
      function ChangeThemesAction(payload) {
        this.type = CHANGE_THEMES;
        this.payload = payload;
      }

      return ChangeThemesAction;
    }();
    var initialState = {
      mode: "light",
      themes: [light, dark]
    };

    var getStartState = function getStartState(options) {
      var themes = options.themes,
          mode = options.mode; // todo [sa] should we support string themes as an input?
      // const themesObjects: any = themes.map((theme: string) => {
      //     theme = theme.replace(/'/g, '"');
      //     return JSON.parse(theme);
      // }) || [];

      if (themes && themes.length !== 0 && mode) {
        return {
          mode: mode,
          themes: themes
        };
      }

      if (mode) {
        return __assign(__assign({}, initialState), {
          mode: mode
        });
      }

      return initialState;
    };

    var ThemeProvider = function ThemeProvider(_a) {
      var themesProps = _a.themes,
          _b = _a.mode,
          themeMode = _b === void 0 ? "light" : _b,
          _c = _a.scoped,
          scoped = _c === void 0 ? false : _c,
          children = _a.children;

      var _d = React.useReducer(function (state, action) {
        switch (action.type) {
          case CHANGE_PALETTE_MODE:
            {
              var mode_1 = action.payload.mode;
              return __assign(__assign({}, state), {
                mode: mode_1
              });
            }

          case CHANGE_THEMES:
            {
              var themes_1 = action.payload.themes;
              themes_1 = Array.isArray(themes_1) ? themes_1 : [themes_1];
              return __assign(__assign({}, state), {
                themes: themes_1
              });
            }

          default:
            {
              return state;
            }
        }
      }, getStartState({
        themes: themesProps,
        mode: themeMode
      })),
          _e = _d[0],
          mode = _e.mode,
          themes = _e.themes,
          dispatch = _d[1];

      var theme = React__default["default"].useMemo(function () {
        var selected = themes.find(function (theme) {
          var _a;

          return ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.mode) === mode;
        });

        if (!selected) {
          throw new Error("Theme not found for mode " + mode);
        }

        return createTheme(selected);
      }, [mode, themes]);
      return jsxRuntime.jsx(styles$1.StylesProvider, __assign({
        injectFirst: true
      }, {
        children: jsxRuntime.jsx(material.ThemeProvider, __assign({
          theme: theme
        }, {
          children: jsxRuntime.jsx(react.ThemeProvider, __assign({
            theme: theme
          }, {
            children: jsxRuntime.jsxs(DispatchContext.Provider, __assign({
              value: dispatch
            }, {
              children: [!scoped && jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [jsxRuntime.jsx(material.CssBaseline, {}, void 0), " ", children, " "]
              }, void 0), scoped && jsxRuntime.jsxs(material.ScopedCssBaseline, {
                children: [" ", children]
              }, void 0)]
            }), void 0)
          }), void 0)
        }), void 0)
      }), void 0);
    };
    function useChangeThemes() {
      var dispatch = React__default["default"].useContext(DispatchContext);
      return React__default["default"].useCallback(function (options) {
        return dispatch(new ChangeThemesAction({
          themes: options
        }));
      }, [dispatch]);
    }
    function useChangePalette() {
      var dispatch = React__default["default"].useContext(DispatchContext);
      return React__default["default"].useCallback(function (options) {
        return dispatch(new ChangePaletteModeAction({
          mode: options
        }));
      }, [dispatch]);
    }

    var systemWidthSize = {
      md: 960,
      lg: 1200,
      xl: 1320
    };

    var breakpoints = __assign({
      values: {
        xs: 0,
        sm: 0,
        md: 0,
        lg: 0,
        xl: 0
      }
    }, breakpoints$1);

    var mq = facepaint__default["default"](["@media (max-width: " + (breakpoints.values.sm - 1) + "px)", "@media (max-width: " + (breakpoints.values.md - 1) + "px) and (min-width: " + breakpoints.values.sm + "px)", "@media (max-width: " + (breakpoints.values.lg - 1) + "px) and (min-width: " + breakpoints.values.md + "px)", "@media (min-width: " + breakpoints.values.lg + "px)", "@media (min-width: " + breakpoints.values.xl + "px)"]);
    var systemWidth = function systemWidth(props) {
      var theme = props.theme;
      return mq({
        width: [systemWidthSize.md, "auto", "auto", systemWidthSize.md, systemWidthSize.lg, systemWidthSize.xl],
        marginRight: ["auto", theme.spacing(2), theme.spacing(3)],
        marginLeft: ["auto", theme.spacing(2), theme.spacing(3)]
      });
    };

    exports.ChangePaletteModeAction = ChangePaletteModeAction;
    exports.ChangeThemesAction = ChangeThemesAction;
    exports.DispatchContext = DispatchContext;
    exports.ThemeProvider = ThemeProvider;
    exports.base = base;
    exports.createTheme = createTheme;
    exports.initialState = initialState;
    exports.systemWidth = systemWidth;
    exports.systemWidthSize = systemWidthSize;
    exports.useChangePalette = useChangePalette;
    exports.useChangeThemes = useChangeThemes;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
